// extracted by mini-css-extract-plugin
export default {"container":"HelpMail_container__3O+DS","image":"HelpMail_image__3krZ6","title":"HelpMail_title__6l3mL","description":"HelpMail_description__pnnb+"};